export const DESIGN_SLIDE_TYPES = {
  ONE: 'DESIGN_SLIDE_ONE',
  TWO: 'DESIGN_SLIDE_TWO',
  THREE: 'DESIGN_SLIDE_THREE',
};

export const SLIDE_GROUP = {
  JOINT_GROUP: 'JOINT_GROUP',
  BOX_GROUP: 'BOX_GROUP',
  JOINT_GROUP_SEQUENCE: 'JOINT_GROUP_SEQUENCE',
  LABEL_BOX_GROUP: 'LABEL_BOX_GROUP',
};

export const SLIDE_NODE = {
  START_NODE: 'START_NODE',
  BOX_DRAG_DROP: 'BOX_DRAG_DROP',
  JOINT_DRAG_DROP: 'JOINT_DRAG_DROP',
  JOINT_PATH_SELECT: 'JOINT_PATH_SELECT',
  END_NODE: 'END_NODE',
};

export const COMPONENT_TYPE = {
  LINK_HEXAGON_MODAL: 'LINK_HEXAGON_MODAL',
  SLIDE_THREE_OPTION: 'SLIDE_THREE_OPTION',
  SLIDE_ONE_OPTION: 'SLIDE_ONE_OPTION',
  PLAIN_TEXT: 'PLAIN_TEXT',
  FULL_WIDTH_IMAGE: 'FULL_WIDTH_IMAGE',
  CSCQ: 'CSCQ',
  MSCQ: 'MSCQ',
  DDQ: 'DDQ',
  DNDQ_COLOR: 'DNDQ_COLOR',
  GROUPED_DNDQ: 'GROUPED_DNDQ',
  GROUPED_CSCQ: 'GROUPED_CSCQ',
  CSCQ_COLOR: 'CSCQ_COLOR',
  SUB_HEADING: 'SUB_HEADING',
  FULL_WIDTH_CARD: 'FULL_WIDTH_CARD',
  SEQUENCE_SLIDER: 'SEQUENCE_SLIDER',
  SEQUENCE_SLIDER_GROUP: 'SEQUENCE_SLIDER_GROUP',
  LABEL: 'LABEL',
  QUESTION_TABLE: 'QUESTION_TABLE',
};

export const NOTEBOOK_SECTIONS = {
  CONTEXT: 'CONTEXT',
  TECHNIQUES: 'TECHNIQUES',
  DESIGN: 'DESIGN',
  PROBLEM_SOLVING: 'PROBLEM_SOLVING',
  RESULTS: 'RESULTS',
  REFLECTION: 'REFLECTION',
  TROUBLESHOOTING: 'TROUBLESHOOTING',
};

export const VISIBILITY = {
  VISIBLE: 'visible',
  HIDDEN: 'hidden',
};

export const QUESTION_CONTENTS = {
  QUESTION: 'question',
  TEXT: 'text',
  IMAGE: 'image',
  TEXT: 'text',
  CONTENT_LIST: 'contentList',
  OPTIONS: 'options',
  GROUPED_OPTIONS1: 'groupedOptions1',
  GROUPED_OPTIONS2: 'groupedOptions2',
  ANSWER_STEPS: 'answerSteps',
  SLIDERS: 'sliders',
  TYPED_OPTIONS: 'typedOptions',
  SLIDER_GROUPS: 'sliderGroups',
  CHECKBOXES: 'checkboxes',
};
